import { mayAutoRefresh, watchBrowserActivity } from "../nightActivity.mjs";
export const PROSP_REFRESH_MS = 5 * 60 * 1000;
const CHANGE_EVENT = "ARFLOW_PROSPECT_CHANGED";
export function notifyProspRefresh() { window.dispatchEvent(new Event(CHANGE_EVENT)); }

// One automatic refresh at a time, only while the operational tab is visible.
// Manual reloads remain available to actions that have just saved a change.
export function watchProspRefresh(reload) {
  let stopped = false;
  let refreshing = false;
  let pendingChange = false;
  const refresh = async () => {
    if (stopped || refreshing || document.visibilityState === "hidden" || !mayAutoRefresh()) return;
    refreshing = true;
    try {
      await reload();
    } finally {
      refreshing = false;
      if (pendingChange && !stopped) {
        pendingChange = false;
        void refresh();
      }
    }
  };
  const changed = () => {
    if (refreshing) pendingChange = true;
    else void refresh();
  };
  const timer = setInterval(refresh, PROSP_REFRESH_MS);
  document.addEventListener("visibilitychange", refresh);
  window.addEventListener("focus", refresh);
  window.addEventListener(CHANGE_EVENT, changed);
  const unwatchActivity = watchBrowserActivity(refresh);
  void refresh();
  return () => {
    stopped = true;
    clearInterval(timer);
    unwatchActivity();
    document.removeEventListener("visibilitychange", refresh);
    window.removeEventListener("focus", refresh);
    window.removeEventListener(CHANGE_EVENT, changed);
  };
}